export class TipoDocumento {
  id: number;
  descricao: string;
}
